import { CircleIconProps } from '../../types/props/CircleIconProps';

const CircleIcon = (props: CircleIconProps) => {
    const circleStyle = {
        backgroundColor: props.color,
        width: props.size,
        height: props.size,
        borderRadius: '50%',
        alignSelf: 'center',
    };

    return <div data-testid="circle-icon" style={circleStyle}></div>;
};

export default CircleIcon;
